var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('b-overlay',{attrs:{"show":_vm.isLoading,"rounded":"sm"}},[_c('vue-good-table',{attrs:{"compactMode":"","styleClass":"vgt-table condensed","columns":_vm.columns,"rows":_vm.groupedData,"row-style-class":_vm.rowStyleClassFn,"pagination-options":{
              enabled: true,
              perPage: 100
          },"group-options":{
              enabled: true,
              collapsable: true,
              headerPosition: 'top'
          },"search-options":{
              enabled: true,
              trigger: 'enter'
          },"select-options":{
              enabled: true,
              selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
              selectionInfoClass: 'custom-class',
              selectionText: 'rows selected',
              clearSelectionText: 'clear',
              disableSelectInfo: true, // disable the select info panel on top
              selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }},scopedSlots:_vm._u([{key:"table-header-row",fn:function(props){return [_c('span',{staticClass:"my-fancy-class"},[_vm._v(" "+_vm._s(props.row.children[0].event.name)+" "),_c('br')]),_c('span',{staticClass:"light-grey-text"},[_vm._v(" "+_vm._s(props.row.children[0].event.date)+", "+_vm._s(props.row.children[0].event.venue.name)+" ")])]}}])})],1)],1)])])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Active Listings")])])
}]

export { render, staticRenderFns }